module.exports = __webpack_public_path__ + "img/exam.05dfed1b.png";